import { Button } from "@ui/Button";
import { navigateToAccountsPath } from "@ui/layouts/AccountLayout/accountsReferrer";

type Props = {
	referrer: "studio" | "askgvt";
};
export const ProfileButton = (props: Props) => {
	return (
		<Button
			class="profile-button"
			layout="icon"
			shape="circle"
			variant="text"
			theme="monochrome"
			symbol="manage_accounts"
			symbolRelativeSize={1.75}
			aria-label="Profile & Accounts"
			onClick={() => navigateToAccountsPath("/account", props.referrer)}
		/>
	);
};
